export default __webpack_public_path__ + "static/media/kitchen4-afterB-1920w.05247c08.webp";